import { useState, useEffect, useRef } from "react";
import {
    Card,
    Col,
    Row,Button,Table,Menu
} from "antd";
import { SearchOutlined,  CheckCircleOutlined, StopOutlined  } from '@ant-design/icons';
import { Input, Space } from 'antd';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { all_data, deleteRecord, updateLessonStatus } from "../store/action/lessons";
import Highlighter from 'react-highlight-words'
import StyleDropdown from "../components/forms/dropdown";
import { useNavigate, Link } from "react-router-dom";
import { exportToExcel } from 'react-json-to-excel';
import { message } from "antd";
import { domain } from "../api";
import RenderHtml from "../components/renderHtml";
// table code start



 
  
  function Lessons() {
    const dispatch = useDispatch()
    const Navigate = useNavigate()
    const lessons = useSelector(state => state.lessons.data, shallowEqual) || []

      // table filter
      const [searchText, setSearchText] = useState('');
      const [searchedColumn, setSearchedColumn] = useState('');
      const [commentDesc, setCommentDesc] = useState(null);
      const searchInput = useRef(null);
      const handleSearch = (selectedKeys, confirm, dataIndex) => {
          confirm();
          setSearchText(selectedKeys[0]);
          setSearchedColumn(dataIndex);
      };
      const handleReset = (clearFilters) => {
          clearFilters();
          setSearchText('');
      };
      const getColumnSearchProps = (dataIndex) => ({
          filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
              <div
                  style={{
                      padding: 8,
                  }}
                  onKeyDown={(e) => e.stopPropagation()}
              >
                  <Input
                      ref={searchInput}
                      placeholder={`Search ${dataIndex}`}
                      value={selectedKeys[0]}
                      onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                      onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                      style={{
                          marginBottom: 8,
                          display: 'block',
                      }}
                  />
                  <Space>
                      <Button
                          type="primary"
                          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                          icon={<SearchOutlined />}
                          size="small"
                          style={{
                              width: 90,
                          }}
                      >
                          Search
                      </Button>
                      <Button
                          onClick={() => clearFilters && handleReset(clearFilters)}
                          size="small"
                          style={{
                              width: 90,
                          }}
                      >
                          Reset
                      </Button>
                  </Space>
              </div>
          ),
          filterIcon: (filtered) => (
              <SearchOutlined
                  style={{
                      color: filtered ? '#0a2471' : undefined,
                  }}
              />
          ),
          onFilter: (value, record) =>
              record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownOpenChange: (visible) => {
              if (visible) {
                  setTimeout(() => searchInput.current?.select(), 100);
              }
          },
          render: (text) =>
              searchedColumn === dataIndex ? (
                  <Highlighter
                      highlightStyle={{
                          backgroundColor: '#ffc069',
                          padding: 0,
                      }}
                      searchWords={[searchText]}
                      autoEscape
                      textToHighlight={text ? text.toString() : ''}
                  />
              ) : (
                  text
              ),
      });
      // table filter

    useEffect(()=>{
      dispatch(all_data())
    },[dispatch])
    
    const deleteOrder = (id) =>{
        var confirmed = window.confirm("Are you sure you want to proceed?");
        if (confirmed) {
          deleteRecord(id).then(res =>{
            if(res.status){
              dispatch(all_data())
              message.success("Successfully deleted")
            }
          })
          .catch(e => message.error("Failed to delete"))
          } 
    }


    const  lessonStatus = (id, status) =>{
        updateLessonStatus(id, status).then(res =>{
          if(res.status){
            dispatch(all_data())
            message.success(res.message)
          }
        })
        .catch(e => message.error("Failed to delete"))
        
  }


    const columns = [
      {
        title: "Image",
        key: "image",
        dataIndex: "image",
        render : (value, row) => (
          value && <div><img src={domain + value} alt="poster image" className="table-image" /></div>
        )
      },
      {
        title: "Title",
        dataIndex: "title",
        key: "title",
        ...getColumnSearchProps('title'),
        render : (value, {id}) => (
          value && <Link to={`/viewSection/${id}`}>{value}</Link>
        )
      },
      {
        title: "Description",
        dataIndex: "description",
        key: "description",
        render : (value, row) => (
          value && <RenderHtml htmlContent={value} />
        )
      },   
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        render : (value, row) => (
          Number(value) ?  <CheckCircleOutlined className="success tick-status" /> :  <StopOutlined className="fail tick-status" />
        )
      },   
      {
        title: 'Actions',
        dataIndex: 'id',
        fixed: 'right',
        width: 150,
        render: (value, {status}) => {
          status = +status
              let menu = (
                    <Menu>
                        <Menu.Item onClick={()=> Navigate(`/addIntoLesson/${value}`)}>Add Section</Menu.Item>
                        <Menu.Item onClick={()=> Navigate(`/editLesson/${value}`)}>View Lesson</Menu.Item>
                        <Menu.Item onClick={()=> lessonStatus(value, status)}>{status ? 'Deactivate Lesson' : 'Activate Lesson'}</Menu.Item>
                        <Menu.Item onClick={()=> deleteOrder(value)}>Delete Lesson</Menu.Item>
                    </Menu>
              )
            return (
              <div>
                <StyleDropdown menu={menu} />
              </div>
                
            )
        }
    },
    ];

    const downloadExcelFile = () =>{
      let excelSheet = [];
      if(lessons?.length === 0){
        message.warning("No Registrations to download")
        return true
      }
      console.log("lessons")
      // lessons?.map((val,key)=>{
      //   excelSheet.push({
      //     'S.NO' : key + 1,
      //     "Name": val.name,
      //     "Phone": val.phone,
      //     "Email": val.email,
      //     "Institute": val.institute,
      //     "Qualification": val.qualification,
      //     "Selected Program": val.selected_program,
      //     "LLB First Year": val.llb_first_year,
      //     "LLB Second Year": val.llb_second_year,
      //     "LLB Third Year": val.llb_third_year,
      //     "IP": val.ip,
      //     "Time": new Date(val.time).toLocaleString()
      //   })
      // })
      // exportToExcel(excelSheet, `registration_${Math.random()}`)
    }

    return (
      <>
   
        <div className="tabled">
          <Row gutter={[24, 0]}>
            <Col xs="24" xl={24}>
              <Card
                bordered={false}
                className="criclebox tablespace mb-24"
                title={(<div className="style-row w-100"><h4 className="text-center">Lessons</h4> <div>
                  <Button type="primary" onClick={downloadExcelFile} className="style-btn d-none">Download Excel File</Button>
                  <Button type="primary" onClick={()=> Navigate('/addLesson')} className="style-b">Add Lesson</Button>
                  </div></div>)}
              >
                <div className="table-responsive">
                  {lessons && lessons.length > 0 &&
                  <Table
                    columns={columns}
                    dataSource={lessons}
                    pagination={false}
                    className="ant-border-space"
                  />
                  }
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </>
    );
  }
  
  export default Lessons;
  